import { Empty } from "antd";

export const sporTableLocale = (description) => ({
  emptyText: (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={description}
      className="spor-table-empty"
    />
  ),
});
